<template>
    <div class="py-4 px-6 my-3">
        <div class="bg-grey-100 rounded-lg">
            <div class="py-4 px-4">
                <div class="grid grid-cols-2 gap-2">
                    <div>
                        <h4 class="text-lg font-semibold mb-3">{{ website.name }} Reviews</h4>
                    </div>
                    <div>
                        <a :href="website.url" target="_blank">
                            <img :src="'/images/logos/tyre-sites/'+logoPath" class="object-scale-down w-20 float-right" />
                        </a>
                    </div>
                </div>
                <div class="inline-block min-w-full overflow-hidden my-4">
                    <table class="table table-auto w-full leading-normal">
                        <thead class="uppercase text-gray-600 text-xs font-semibold bg-gray-200">
                            <tr class="hidden lg:table-row">
                                <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider hidden md:table-cell" width="60">&nbsp;</th>
                                <th v-for="text in tableHeader" class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider hidden md:table-cell">
                                    {{ text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading" class="my-3 flex-1 lg:flex-none">
                            <tr v-for="(key, stat) in stats" class="mb-2 lg:mb-0 border-2 lg:border-b-2 border-grey-200 lg:border-t lg:first:border-t-0 flex p-1 md:p-3 hover:bg-gray-100 lg:table-row flex-col w-full flex-wrap">
                                <td class="p-1 lg:p-5 lg:border-l-2 lg:border-b border-grey-200 bg-white uppercase text-sm text-left tracking-wider">
                                    <span class="font-bold">{{ stat }}</span>
                                </td>
                                <td v-for="value in key" class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                    {{ value }}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else class="text-center h-[200px] w-full bg-white">
                            <tr>
                                <td colspan="4" class="text-center">
                                    <font-awesome-icon
                                        class="animate-spin transition-all text-dark"
                                        size="5x"
                                        :icon="['fas', 'tire']"
                                    ></font-awesome-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

export default {
    name: "AdminWebsite",
    components: {
        FontAwesomeIcon
    },
    props:
    {
        website: Object
    },
    data: function()
    {
        return {
            logoPath: this.website !== null ? this.website.name.toLowerCase() + '.png' : null,
            stats:[],
            loading: false,
            tableHeader: this.$trusted_checks.value ? [
                'Reviews', 'Feedback', 'Product'
            ] : [
                'Site', 'Fitter', 'Tyres'
            ]
        }
    },
    mounted()
    {
        let self = this;

        this.getStats();

        setInterval(function ()
        {
            self.getStats();
        }, 300000); // 5 Minutes
    },
    methods:
    {
        async getStats()
        {
            this.loading = true;

            const response = await axios.get(this.route("admin.stats", this.website.id), {});

            this.stats = response.data;

            this.loading = false;
        }
    }
}
</script>

<style scoped>

</style>
